import { ServiceMode } from 'state/service-mode';

interface IGetOrderProcessingTextParams {
  isCashPayment: boolean;
  enableImCloseDisplay: boolean;
  serviceMode: ServiceMode;
}
export const getOrderProcessingText = ({
  isCashPayment,
  enableImCloseDisplay,
  serviceMode,
}: IGetOrderProcessingTextParams) => {
  const showImClose = enableImCloseDisplay && serviceMode !== ServiceMode.CURBSIDE;

  return isCashPayment
    ? showImClose
      ? 'orderProcessingDisclaimerImCloseCashPayment'
      : 'orderProcessingDisclaimerCashPayment'
    : showImClose
    ? 'orderProcessingDisclaimerImClose'
    : 'orderProcessingDisclaimer';
};
